import script from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&setup=true"

import "./BasicInfo.vue?vue&type=style&index=0&id=4cf0b3fc&lang=less"
import "./BasicInfo.vue?vue&type=style&index=1&id=4cf0b3fc&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf0b3fc"]])

export default __exports__